<template>
  <b-col>
    <b-card no-body>
      <b-card-body>
        <h3 class="font-weight-bold font-medium-3 ml-1">
          {{ t('Consignor Informations') }}
        </h3>
        <validation-observer ref="consignorInformationsForm" tag="form">
          <b-col>
            <validation-provider #default="{ errors }" :name="t('Consignor')" vid="consignor">
              <b-form-group label-for="consignor">
                <div class="d-flex form-group-label">
                  <label for="name">{{ t('Consignor') }}</label>
                  <span class="text-danger">*</span>
                </div>
                <b-form-input
                  v-model="consignorInformations.name"
                  :state="errors.length > 0 ? false : null"
                  :placeholder="t('Consignor')"
                  type="text"
                  :disabled="!editable"
                />
                <small class="text-danger">{{ errors[0] }}</small>
              </b-form-group>
            </validation-provider>
            <validation-provider
              #default="{ errors }"
              :name="t('Attention Name')"
              :rules="consignorInformations.attention_name ? '' : 'required'"
              vid="consignor_attention_name"
            >
              <b-form-group label-for="consignor">
                <div class="d-flex form-group-label">
                  <label for="name">{{ t('Attention Name') }}</label>
                  <span class="text-danger">*</span>
                </div>
                <b-form-input
                  v-model="consignorInformations.attention_name"
                  :state="errors.length > 0 ? false : null"
                  :placeholder="t('Consignor')"
                  type="text"
                  :disabled="!editable"
                />
                <small class="text-danger">{{ errors[0] }}</small>
              </b-form-group>
            </validation-provider>
            <validation-provider
              #default="{ errors }"
              :name="t('Phone Number')"
              :rules="consignorInformations.phone ? '' : 'required'"
              vid="consignor_phone_number"
            >
              <b-form-group label-for="consignor">
                <div class="d-flex form-group-label">
                  <label for="name">{{ t('Phone Number') }}</label>
                  <span class="text-danger">*</span>
                </div>
                <b-form-input
                  v-model="consignorInformations.phone"
                  :state="errors.length > 0 ? false : null"
                  :placeholder="t('Phone Number')"
                  type="text"
                  :disabled="!editable"
                />
                <small class="text-danger">{{ errors[0] }}</small>
              </b-form-group>
            </validation-provider>
            <validation-provider
              #default="{ errors }"
              :name="t('Address')"
              rules="required"
              vid="consignor_address"
            >
              <b-form-group label-for="consignor_address">
                <div class="d-flex form-group-label">
                  <label for="name">{{ t('Address') }}</label>
                  <span class="text-danger">*</span>
                </div>
                <b-form-input
                  v-model="consignorInformations.address"
                  :state="errors.length > 0 ? false : null"
                  :placeholder="t('Address')"
                  tabindex="4"
                  :disabled="!editable"
                />
                <small class="text-danger">{{ errors[0] }}</small>
              </b-form-group>
            </validation-provider>
            <validation-provider
              #default="{ errors }"
              :name="t('Country')"
              rules="required"
              vid="consignor_country"
            >
              <b-form-group label-for="consignor_country" :state="errors.length > 0 ? false : null">
                <div class="d-flex form-group-label">
                  <label for="name">{{ t('Country') }}</label>
                  <span class="text-danger">*</span>
                </div>
                <v-select
                  id="consignor_country"
                  v-model="consignorInformations.country"
                  :options="countries"
                  :placeholder="t('Make a Choice')"
                  label="text"
                  @input="getConsignorStateList"
                  :disabled="!editable"
                >
                  <span slot="no-options">{{ t('No records found') }}</span>
                </v-select>
                <b-form-invalid-feedback :state="errors.length > 0 ? false : null">
                  {{ errors[0] }}
                </b-form-invalid-feedback>
              </b-form-group>
            </validation-provider>
            <b-row>
              <b-col md="6" lg="4">
                <b-form-group label-for="consignor_postal_code">
                  <validation-provider
                    #default="{ errors }"
                    :name="t('Postal Code')"
                    :rules="consignorPostalCodeRequired ? 'required' : null"
                    vid="consignor_postal_code"
                    ref="consignorPostalCodeValidation"
                  >
                    <div class="d-flex form-group-label">
                      <label for="name">{{ t('Postal Code') }}</label>
                      <span class="text-danger">*</span>
                    </div>
                    <v-select
                      :disabled="!(consignorPostalCodeRequired && editable)"
                      v-model="consignorInformations.postal_code"
                      :loading="consignorPostalCodeLoading"
                      :options="postalCodeOptions"
                      :placeholder="t('Enter Postal Code')"
                      label="combinedLabel"
                      @input="handleFromPostalCode"
                      @search="handlePostalCodeSearch"
                    >
                      <span slot="no-options">{{ t('No records found') }}</span>
                    </v-select>
                    <small class="text-danger">{{ errors[0] }}</small>
                  </validation-provider>
                </b-form-group>
              </b-col>
              <b-col md="6" lg="4">
                <validation-provider
                  #default="{ errors }"
                  ref="consignorStateValidation"
                  :name="t('City')"
                  rules="required"
                  vid="consignor_state"
                >
                  <b-form-group
                    label-for="consignor_state"
                    :state="errors.length > 0 ? false : null"
                  >
                    <div class="d-flex form-group-label">
                      <label for="name">{{ t('City') }}</label>
                      <span class="text-danger">*</span>
                    </div>
                    <v-select
                      :disabled="consignorPostalCodeRequired"
                      id="consignor_state"
                      v-model="consignorInformations.state"
                      :options="consignorStates"
                      :placeholder="t('Make a Choice')"
                      label="text"
                      @input="getConsignorCityList"
                    >
                      <span slot="no-options">{{ t('No records found') }}</span>
                    </v-select>
                    <b-form-invalid-feedback :state="errors.length > 0 ? false : null">
                      {{ errors[0] }}
                    </b-form-invalid-feedback>
                  </b-form-group>
                </validation-provider>
              </b-col>
              <b-col md="6" lg="4">
                <validation-provider
                  #default="{ errors }"
                  ref="consignorCityValidation"
                  :name="t('District')"
                  rules="required"
                  vid="consignor_city"
                >
                  <b-form-group
                    label-for="consignor_city"
                    :state="errors.length > 0 ? false : null"
                  >
                    <div class="d-flex form-group-label">
                      <label for="name">{{ t('District') }}</label>
                      <span class="text-danger">*</span>
                    </div>
                    <v-select
                      :disabled="consignorPostalCodeRequired"
                      id="consignor_city"
                      v-model="consignorInformations.city"
                      :options="consignorCities"
                      :placeholder="t('Make a Choice')"
                      label="text"
                    >
                      <span slot="no-options">{{ t('No records found') }}</span>
                    </v-select>
                    <b-form-invalid-feedback :state="errors.length > 0 ? false : null">
                      {{ errors[0] }}
                    </b-form-invalid-feedback>
                  </b-form-group>
                </validation-provider>
              </b-col>
            </b-row>
          </b-col>
        </validation-observer>
      </b-card-body>
    </b-card>
  </b-col>
</template>
<script>
import { useUtils as useI18nUtils } from '@core/libs/i18n';
import {
  BRow,
  BCol,
  BCard,
  BCardBody,
  BFormInput,
  BFormGroup,
  BFormInvalidFeedback
} from 'bootstrap-vue';
import vSelect from 'vue-select';
import { mapGetters } from 'vuex';
import { helper } from '@core/mixins/helper.js';
import useService from '@/auth/service/useService';
import debounce from 'lodash.debounce';
import { ValidationProvider, ValidationObserver } from 'vee-validate';

export default {
  components: {
    BRow,
    BCol,
    BCard,
    BCardBody,
    BFormInput,
    BFormGroup,
    BFormInvalidFeedback,

    vSelect,

    ValidationProvider,
    ValidationObserver
  },
  mixins: [helper],
  props: {
    consignorInformations: {
      type: Object
    },
    editable: {
      type: Boolean,
      default: true
    }
  },
  data() {
    return {
      consignorPostalCodeRequired: true,
      consignorPostalCodeLoading: false,
      filteredPostalCodes: [],
      postalCodes: [],
      minimumPostalCodeLength: 3
    };
  },
  watch: {
    consignorInformations: {
      async handler() {
        await this.prepareCountryData();
        await this.prepareStateData();
        await this.prepareCityData();
      },
      immediate: true
    }
  },
  computed: {
    ...mapGetters({
      countries: 'app/countries',
      consignorStates: 'app/consignorStates',
      consignorCities: 'app/consignorCities',
      preferences: 'app/preferences'
    }),
    postalCodeOptions() {
      return this.mapToOptions(this.filteredPostalCodes);
    }
  },
  methods: {
    async prepareCountryData() {
      await this.$store.dispatch('app/getCountries');

      this.consignorInformations.country = this.countries.find(a => {
        return a.iso3 === this.consignorInformations.countryIso3;
      });

      this.consignorPostalCodeRequired = this.consignorInformations.country.isPostalCodeRequired;
      if (!this.consignorPostalCodeRequired) {
        this.consignorInformations.postal_code = '';
        this.$refs.consignorPostalCodeValidation.reset();
      }
    },
    async prepareStateData() {
      await this.$store.dispatch(
        'app/getConsignorStates',
        this.consignorInformations.country.value
      );

      this.consignorInformations.state = this.consignorStates.find(item => {
        return item.text === this.consignorInformations.state;
      });
    },
    async prepareCityData() {
      this.$store.dispatch('app/getConsignorCities', {
        countryId: this.consignorInformations.country.value,
        cityId: this.consignorInformations.state.value
      });
    },
    async getConsignorStateList(data) {
      this.consignorInformations.state = '';
      this.$refs.consignorStateValidation.reset();

      this.consignorInformations.postal_code = '';
      this.$refs.consignorPostalCodeValidation.reset();

      this.getConsignorCityList('');

      this.postalCodes = [];
      this.filteredPostalCodes = [];

      if (data && data.value) {
        this.consignorPostalCodeRequired = data.isPostalCodeRequired;
        await this.$store.dispatch('app/getConsignorStates', data.value);
      }
    },
    getConsignorCityList(data) {
      this.consignorInformations.city = '';
      this.$refs.consignorCityValidation.reset();

      if (data && data.value) {
        this.$store.dispatch('app/getConsignorCities', {
          countryId: this.consignorInformations.country.value,
          cityId: data.value
        });
      }
    },
    handleFromPostalCode(data) {
      if (data) {
        this.consignorInformations.state = data.state;
        this.consignorInformations.city = data.city;
      }
    },
    handlePostalCodeSearch: debounce(function handlePostalCodeSearch(postalCode) {
      if (postalCode.length >= this.minimumPostalCodeLength) {
        this.filterPostalCodes(postalCode);
      }
    }, 300),
    filterPostalCodes(postalCode) {
      const data = {
        country_code: this.consignorInformations.country.iso2,
        zipcode: postalCode
      };
      this.consignorPostalCodeLoading = true;
      useService
        .autoPostalCodes(data)
        .then(response => {
          this.postalCodes = response.data;
          const filtered = this.postalCodes.filter(code => code.zipcode.includes(postalCode));
          this.filteredPostalCodes = filtered.map(code => ({
            place: code.place,
            zipcode: code.zipcode,
            state: code.state,
            city: code.province
          }));
        })
        .finally(() => {
          this.consignorPostalCodeLoading = false;
        });
    },
    mapToOptions(list) {
      return list.map(code => ({
        value: code.zipcode,
        combinedLabel: `${code.zipcode} - ${code.place}`,
        state: code.state,
        city: code.city
      }));
    }
  },
  setup() {
    const { t } = useI18nUtils();

    return {
      t
    };
  }
};
</script>
<style lang="scss">
@import '@core/scss/vue/libs/vue-wizard.scss';
@import '@core/scss/vue/libs/vue-select.scss';
</style>
